var map = {
	"./BaseBox.vue": "e1fc",
	"./BaseImg.vue": "d4e5",
	"./BasePoster.vue": "c2de",
	"./NewsPoster.vue": "e92e",
	"./RoundImg.vue": "35ac",
	"./SectionHeading.vue": "db4f",
	"./SquareImg.vue": "da84a",
	"./icons/IconCamera.vue": "086b",
	"./icons/IconCross.vue": "948b",
	"./icons/IconEnvelope.vue": "c093",
	"./icons/IconInstagram.vue": "31fa",
	"./icons/IconTilde.vue": "35e6",
	"./icons/IconTwitter.vue": "07dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e51e";